import { z } from 'zod'

/** Aceita string numérica: o load pode trazer id como string e o resolver não pode rejeitar. */
export const optionalNumber = z.preprocess((val) => {
  if (val === null || val === '' || val === undefined || val === 'null') {
    return undefined
  }
  if (typeof val === 'number' && !isNaN(val)) {
    return val
  }
  if (typeof val === 'string') {
    const num = Number(val.trim())
    return isNaN(num) ? undefined : num
  }
  return undefined
}, z.number().optional())

/** Coluna nullable chega como null no load; o resolver só aceita undefined. */
export const optionalString = z.preprocess((val) => {
  if (val === null || val === 'null') {
    return undefined
  }
  return val
}, z.string().optional())


export const orderCoreSchema = z.object({
  supplier: optionalString,
  supplierId: optionalNumber,
  supplierDetails: z.record(z.any()).optional(),
  seller: optionalString,
  sellerId: optionalNumber,
  sellerDetails: z.record(z.any()).optional(),
  client: optionalString,
  clientId: optionalNumber,
  clientDetails: z.record(z.any()).optional(),
  orderType: optionalString,
  orderTypeId: optionalNumber,
  representativeId: optionalNumber,
  representativeName: optionalString,
  orderSituationId: optionalNumber,
  orderSituationName: optionalString,
  generalClassId: optionalNumber,
  generalClassName: optionalString,
  extraInfo: optionalString,
  criticalAnalysis: z.boolean().optional(),
  criticalAnalysisDesc: optionalString,
  shippingTypeId: optionalNumber,
  shippingTypeName: optionalString,
  trackingCode: optionalString,
  orderDate: optionalString,
  deliveryDate: optionalString,
  billingDate: z.string().optional().nullable(),
  paymentConditionId: optionalNumber,
  paymentConditionName: optionalString,
  paymentMethodId: optionalNumber,
  paymentMethodName: optionalString,
  clientOrderNumber: optionalNumber,
  /** valor em reais; o rateio distribui este total entre os itens */
  sellingPrice: optionalNumber,
})

export type OrderCoreSchemaType = z.infer<typeof orderCoreSchema>
